import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { BehaviorSubject, debounceTime, Observable, ObservableInput, switchMap } from 'rxjs';
import { ProjectPlanViewModel } from '../../models-views/project-plan.view.model';
import { ProjectResponseModel } from '../../models/project.model';
import LoginModel from '../../models/user.model';
import { AppCommon } from '../../providers/app-common';

interface IModalData {
  id: number;
  name: string;
}

@Component({
  selector: 'app-add-project-plan',
  standalone: false,
  templateUrl: './add-project-plan.component.html',
  styleUrl: './add-project-plan.component.scss',
  providers: [ProjectPlanViewModel]
})
export class AddProjectPlanComponent {

  projectListData = new BehaviorSubject<ProjectResponseModel>(new ProjectResponseModel());
  modalData?: IModalData;

  constructor(private modalRef: NzModalRef, private vm: ProjectPlanViewModel) { 
     this.loginModel.next(AppCommon.getloggedInObject()); 
     this.modalData = inject(NZ_MODAL_DATA); // Moved here
  }
 
  searchChange$ = new BehaviorSubject('');
  optionList: any[] = [];
  selectedProject?: number;
  loading = false;
  loginModel = new BehaviorSubject<LoginModel>(new LoginModel());

  ngOnInit(): void {
    this.vm.parentAddProjectPlanComponent = this;
    this.vm.subscribeToprojectList(this.projectListData);
    this.searchChange$.pipe(debounceTime(500)).subscribe(name => {
      if(!name) return; 
      this.getProjectList(name)
    });
  } 

  ngAfterViewInit(): void {
    if(this.modalData?.id){
      const name = this.modalData.name
      this.getProjectList(name);
    }
  }
  
  onSearch(value: string): void {
    this.loading = true;
    this.searchChange$.next(value);
  }

  getProjectList(name: string) {
    this.vm.getProjectList(name);
  }

  projectDataReceived(){
    this.optionList = this.projectListData.value.results; 
    if(this.modalData?.id){
      this.selectedProject = this.modalData.id;
    }
    this.loading = false;
  }
 
  close(): void {
    this.modalRef.close(false);
  }

  create(): void {
    this.vm.createProjectPlan(this.selectedProject, this.loginModel.value.user.id);
  }

  projectPlanCreated(){
    this.modalRef.close(true);
  }
}
